import domainConfiguration from '@/config/services/domains';

export const getDomainTitle = () => {
  const { name: title } = domainConfiguration;
  return title;
};
